import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import VedioPlayer from "../Vedio-player/VedioPlayer";
import VimeoPlayer from "../Vedio-player/Vimeo";
import { createOrupdateWatchTime } from "../../apiCalls/userApiCalls";
import { useDispatch } from "react-redux";

export const SubjectPageItem = (props) => {
  
  const dispatch = useDispatch();
  const updateWatchTimes = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const { _id, watchTime } = props.video;

    if (watchTime === null) {
      const data = {
        userId: user._id,
        videoId: _id,
        watchCount: 1,
        watchMap: [new Date()],
      };
      createOrupdateWatchTime(dispatch, data);
    } else {
      const data = {
        ...watchTime,
        watchCount: watchTime.watchCount + 1,
        watchMap: [...watchTime.watchMap, new Date()],
      };
      createOrupdateWatchTime(dispatch, data);
    }
  };
  const {
    _id,
    videoUrl,
    title,
    description,
    limit,
    lessonId,
    thumbnail,
    watchTime,
    isLocked,
    createdAt,
  } = props.video;

  return (
    <div>
      <Card
        sx={{
          margin: "10px",
          boxShadow: "10px 10px 10px 10px rgba(0,0,0,0.2)",
        }}
      >
        {/* <CardMedia sx={{ height: 240 }} image={heroImg} title="green iguana" /> */}
        <VedioPlayer
          url={isLocked ? "" : videoUrl}
          watchTime={watchTime}
          thumbnail={thumbnail}
          updateWatchTimes={updateWatchTimes}
      
        />

        {/* <VimeoPlayer
          url={videoUrl}
          watchTime={watchTime}
          thumbnail={thumbnail}
          updateWatchTimes={updateWatchTimes}
          isLocked={isLocked}
        /> */}

        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </div>
        </CardContent>
        <CardActions>
          {watchTime === null ? (
            <Button size="small">
              Remaining number of times{" "}
              <Typography
                sx={{
                  color: "green",
                  fontWeight: "bold",
                  marginLeft: "10px",
                  marginBottom: "5px",
                  fontSize: "20px",
                }}
              >
                {limit}
              </Typography>
            </Button>
          ) : (
            <Button size="small">
              Remaining number of times{" "}
              <Typography
                sx={{
                  color: limit - watchTime.watchCount > 3 ? "green" : "red",
                  fontWeight: "bold",
                  marginLeft: "10px",
                  marginBottom: "5px",
                  fontSize: "20px",
                }}
              >
                {" "}
                {limit - watchTime.watchCount}
              </Typography>
            </Button>
          )}
        </CardActions>
      </Card>
    </div>
  );
};
